import { Typography } from '@mui/material'
import BackupTableIcon from '@mui/icons-material/BackupTable';
import React from 'react'

export const NoData = () => {
  return (
     <div className={`d-flex justify-content-center no-data-found gap-2`}><BackupTableIcon color='primary' /><Typography color='primary'>No Data Found</Typography></div>
  )
}
